import React from "react";
import { Link } from "react-router-dom";
import MarketingShell from "../MarketingShell";
import SEOHead from "../../components/SEOHead";
import POLICIES from "./policies.json";
import "./policy.css";

/**
 * Store policy pages: /shipping-returns, /privacy, /terms.
 *
 * The wording lives in policies.json (also read by scripts/prerender.js for
 * crawlers). It was approved in the "Umoona online store policies" doc; change
 * both together. Google Merchant Center checks these pages before listing
 * products.
 */

// "**bold**" → <strong>; emails, the phone number and oaic.gov.au → links
const TOKEN = /(\*\*[^*]+\*\*|[\w.+-]+@[\w-]+\.[\w.]+|\(08\) 8672 5288|oaic\.gov\.au)/g;

function rich(text) {
  return text.split(TOKEN).map((part, i) => {
    if (!part) return null;
    if (part.startsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
    if (part.includes("@")) return <a key={i} href={`mailto:${part}`}>{part}</a>;
    if (part === "(08) 8672 5288") return <a key={i} href="tel:+61886725288">{part}</a>;
    if (part === "oaic.gov.au") return <a key={i} href="https://www.oaic.gov.au" target="_blank" rel="noreferrer">{part}</a>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export default function RPolicyPage({ policy }) {
  const page = POLICIES.pages.find((p) => p.key === policy);
  const others = POLICIES.pages.filter((p) => p.key !== policy);

  return (
    <MarketingShell pageClass="pg-policy">
      <SEOHead title={page.seoTitle} description={page.description} canonical={page.path} />

      <article className="pol">
        <header className="pol-head">
          <div className="pol-eyebrow">{page.eyebrow}</div>
          <h1 className="pol-title">{page.title}</h1>
          {page.intro && <p className="pol-intro">{rich(page.intro)}</p>}
        </header>

        {page.sections.map((section) => (
          <section key={section.heading} className="pol-section">
            <h2>{section.heading}</h2>
            {section.list && (
              <ul>
                {section.list.map((item) => (
                  <li key={item}>{rich(item)}</li>
                ))}
              </ul>
            )}
            {(section.paras || []).map((para) => (
              <p key={para}>{rich(para)}</p>
            ))}
          </section>
        ))}

        <footer className="pol-foot">
          <span>Last updated {POLICIES.updated}</span>
          <span className="pol-foot__links">
            {others.map((p) => (
              <Link key={p.key} to={p.path}>
                {p.title}
              </Link>
            ))}
          </span>
        </footer>
      </article>
    </MarketingShell>
  );
}
